export default "__VITE_ASSET__CC4iPwxL__"